var wFlag = window.innerWidth>750

function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            toggleActions: 'play none none reverse',
        }
    })
}

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<30;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlim4_box3_${i}.avif`;
    }
    
};
preloadImages()

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

onViewLoad('.lazy_video')

$(()=>{
    setInterval(() => {
        $('.box1_title').css({ transform: 'translateY(0)', opacity: 1 })
    }, 500);

    //box2
    ScrollTrigger.create({
        trigger:'.box2_title',
        start:'top bottom-=20%',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_title',{opacity:0,duration:0.5})
    })
    showUp('.box2_text')
    ScrollTrigger.create({
        trigger:'.box2_item',
        start:'top bottom-=10%',
        end:'+=60%',
        scrub:1,
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
    })
    showUp('.box2_info div')

    //box3
    // showUp('.box3_title')
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_item div p').removeClass('box3Active')
                $('.box3_item div').eq(index).find('p').addClass('box3Active')
            }
        },
    })
    $('.box3_item div').click(function(){
        box3Swiper.slideTo($(this).index()+1, 300);
    })

    //box4
    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top+=14% top':'top+=14% top+=4%',
        end:'+=10%',
        scrub:1,
        animation:gsap.timeline()
            .to('.box4_info',{scale:2,opacity:0})
    })
    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top+=24% top':'top+=24% top+=4%',
        end:'+=80%',
        //markers:true,
        scrub:1,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 28);
            $('.box4_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xlim4_box3_${index+1}.avif`)
        },
        animation:gsap.timeline()
            .to('.box4_img',{scale:1,y:0})
    })
    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top+=104% top':'top+=104% top+=4%',
        end:'+=30%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box4_1,.box4_cImg,.box4_tips,.box4_btn',{opacity:0})
    })
    function getNum(type,id){
        if(type=='desktop'){
            if(id==0){
                return -35
            }else if(id==2){
                return 36
            }else{
                return 0
            }
        }else{
            if(id==0){
                return 36
            }else if(id==2){
                return -35
            }else{
                return 0
            }
        }
    }
    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top+=130% top':'top+=130% top+=4%',
        end:'+=70%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            for(let i=0;i<3;i++){
                if(index>i*40){
                    $('.box4_cImg img').eq(i).addClass('opacity1').siblings().removeClass('opacity1')
                    $('.box4_title p').eq(i).addClass('opacity1').siblings().removeClass('opacity1')
                    if(wFlag){
                        $('.box4_icon p img').eq(i).addClass('opacity1').siblings().removeClass('opacity1')
                        $('.box4_mask').css({transform:`rotate(${getNum('desktop',i)}deg)`})
                    }else{
                        $('.box4_btn p').eq(i).addClass('box4Active').siblings().removeClass('box4Active')
                        $('.box4_icon p img').eq(i).addClass('opacity1').siblings().removeClass('opacity1')
                        $('.box4_icon p img').css({transform:`rotate(${getNum('mobile',i)}deg)`})
                    }
                }
            }
        }
    })
    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top+=4% top':'top+=4% top+=4%',
        end:'+=210%',
        pin:true,
    })
    if(!wFlag){
        $('.box4_btn p:nth-child(1)').addClass('box4Active')
    }
    var a = 0
    // $('.box4_btn p').click(function(){
    //     var index = $(this).index()
    //     if(wFlag){
    //         if(index==0){
    //             a=-35
    //         }else if(index==2){
    //             a=36
    //         }else{
    //             a=0
    //         }
    //         $('.box4_icon p img').eq(index).addClass('opacity1').siblings().removeClass('opacity1')
    //         $('.box4_mask').css({transform:`rotate(${a}deg)`})
    //     }else{
    //         if(index==0){
    //             a=36
    //         }else if(index==2){
    //             a=-35
    //         }else{
    //             a=0
    //         }
    //         $(this).addClass('box4Active').siblings().removeClass('box4Active')
    //         $('.box4_icon p img').eq(index).addClass('opacity1').siblings().removeClass('opacity1')
    //         $('.box4_icon p img').css({transform:`rotate(${a}deg)`})
    //     }
    //     $('.box4_cImg img').eq(index).addClass('opacity1').siblings().removeClass('opacity1')
    //     $('.box4_title p').eq(index).addClass('opacity1').siblings().removeClass('opacity1')
    // })
    

    //box5
    

    ScrollTrigger.create({
        trigger:'.box5',
        start:'top+=10% top+=6%',
        end:'+=40%',
        scrub:1,
        //toggleActions: 'play none none reverse',
        animation:gsap.timeline()
            .to('.box5_info',{opacity:0})
            .to('.box5_O',{transform:wFlag?'scale(5) translate(30%, 16%)':'scale(6) translate(42%, 0%)',border:wFlag?'0.7rem solid white':'0.4rem solid white'})
            .from('.box5_img,.box5_circle,.box5_items,.box5_Micon div',{opacity:0})
    })
    ScrollTrigger.create({
        trigger:'.box5',
        start:'top+=60% top+=6%',
        end:'+=200%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            for(let i=0;i<8;i++){
                if(index>i*12){
                    $(`.box5_img p img:nth-child(${i+1})`).addClass('opacity1').siblings().removeClass('opacity1')
                    if(i<3){
                        $('.box5_items .box5_item:nth-child(1)').addClass('box5Active').siblings().removeClass('box5Active') 
                    }else if(i<6){
                        $('.box5_items .box5_item:nth-child(2)').addClass('box5Active').siblings().removeClass('box5Active') 
                        $(`.box5_right div:nth-child(2) p:nth-child(${i-2})`).addClass('white').siblings().removeClass('white')
                    }else{
                        $('.box5_items .box5_item:nth-child(3)').addClass('box5Active').siblings().removeClass('box5Active') 
                    }
                    if(!wFlag){
                        if(i<3){
                            $('.box5_Micon').css({transform:'translate(-50%) scale(3.5) rotate(0deg)'})
                        }else if(i<6){
                            $('.box5_Micon').css({transform:'translate(-50%) scale(3.5) rotate(45deg)'})
                        }else{
                            $('.box5_Micon').css({transform:'translate(-50%) scale(3.5) rotate(90deg)'})
                        }
                    }
                }
            }
        }
    })
    ScrollTrigger.create({
        trigger:'.box5',
        start:wFlag?'top top+=6%':'top top+=8%',
        end:'+=270%',
        pin:true,
    })

    //box6
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top+=10% top+=6%':'top+=10% top+=2%',
        end:'+=60%',
        scrub:1,
        //toggleActions: 'play none none reverse',
        animation:gsap.timeline()
            .to('.box6_info',{scale:2,opacity:0})
            .from('.box6_1',{opacity:0},'-=20%')
            .from('.box6_title,.box6_item',{opacity:0,y:'2rem'},'-=20%')
    })
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top top+=6%':'top top+=2%',
        end:'+=100%',
        pin:true,
    })

    //box7
    showUp('.box7_title')
    ScrollTrigger.create({
        trigger:'.box7',
        start:wFlag?'top top+=30%':'top center',
        end:'+=0%',
        once: true,
        onEnter: () => {
            $('.box7_item div:nth-child(1) video')[0].play()
        }
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top+=15% top+=4%',
            end:'+=30%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box7_item',{x:'-25%'})
                .from('.box7_title div:last-child',{y:'2rem',opacity:0},'-=80%')
        })
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top+=35% top+=4%',
            end:'+=0%',
            //toggleActions: 'play none none reverse',
            animation:gsap.timeline()
                .to('.box7_item div:last-child p img:nth-child(2)',{clipPath:'inset(0% 0% 0% 0%)'})
                .from('.box7_item div:last-child p img:nth-child(3)',{opacity:0})
        })
        ScrollTrigger.create({
            trigger:'.box7',
            start:'top top+=4%',
            end:'+=60%',
            pin:true,
        })
    }else{
        showUp('.Mbox7_title')
        ScrollTrigger.create({
            trigger:'.Mbox7',
            start:'top center',
            end:'+=0%',
            //toggleActions: 'play none none reverse',
            animation:gsap.timeline()
                .to('.Mbox7_item p img:nth-child(2)',{clipPath:'inset(0% 0% 0% 0%)'})
                .from('.Mbox7_item p img:nth-child(3)',{opacity:0})
        })
    }

    //box11
    showUp('.box11_title')

    //box9
    showUp('.box9_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9',
            start:'top center',
            end:'+=20%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box9Swiper .swiper-wrapper .swiper-slide:nth-child(1)',{opacity:0,x:'100%'})
                .from('.box9Swiper .swiper-wrapper .swiper-slide:nth-child(3)',{opacity:0,x:'-100%'},'<')
        })
    }else{
        new Swiper('.box9Swiper', {
            autoplay: true,
            loop:true,
            pagination: {
                el: '.box9Swiper-pagination',
                clickable:true
            }
        })
    }

    //box10
    ScrollTrigger.create({
        trigger:'.box10',
        start:'top+=15% top+=5%',
        end:'+=0%',
        toggleActions: 'play none none reverse',
        animation:gsap.timeline()
            .to('.box10_mask',{x:wFlag?'0':'6.5%',y:wFlag?'6%':'4%',scale:wFlag?0.58:0.6,opacity:0})
    })
    ScrollTrigger.create({
        trigger:'.box10',
        start:'top+=50% top+=5%',
        end:'+=20%',
        scrub:1,
        animation:gsap.timeline()
            .to('.box10_item',{x:wFlag?'-38%':'-52%'})
    })

    ScrollTrigger.create({
        trigger:'.box10',
        start:'top top+=5%',
        end:'+=100%',
        pin:true
    })

    //box8
    showUp('.box8_title')
    new Swiper('.box8Swiper2', {
        autoplay:true,
        pagination: {
            el: '.box8Swiper2-pagination',
            clickable:true
        }
    })
    

    //box13
    showUp('.box13_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box13Swiper',
            start:'top bottom-=20%',
            end:'+=40%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline().to('.box13Swiper .swiper-slide',{x:0,opacity:1})
        })
        $('.box13_item').hover(function(){
            $('.box13_item video').each(function() {
                this.pause();
            });
            $(this).find('video')[0].play();
        })
    }else{
        new Swiper('.box13Swiper', {
            slidesPerView: 1.5,
            centeredSlides: true,
            autoplay:true,
            on:{
                slideChangeTransitionEnd: function(){
                    $('.box13_item video').css({filter:'brightness(0.4)'})
                    $('.box13_item video').each(function() {
                        this.pause();
                    });
                    $('.box13Swiper .swiper-slide-active .box13_item video').css({filter:'none'})
                    $('.box13Swiper .swiper-slide-active .box13_item video')[0].play()
                },
            },
        })
    }

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })
    

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
       window.open('https://store.oxva.com/products/oxva-xlim-4'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})